import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
import { css } from 'styled-components';
import { isDefined } from '../helpers/defined';
import { styleArrayForBreakpoints } from '../helpers/media-style';
/*
 * Wrapper that adds support to the following props
 * - 'withSpacing'
 * - 'withTopMargin'
 * - 'withBottomMargin'
 * - 'withTopPadding'
 * - 'withBottomPadding'
 */

export var fontSpacingMixin = byMedia(function (value) {
  return css(_templateObject(), function (_ref) {
    var withSpacing = _ref.withSpacing,
        withTopPadding = _ref.withTopPadding;
    return (withSpacing || withTopPadding) && "padding-top: " + getPx(value) + ";";
  }, function (_ref2) {
    var withTopMargin = _ref2.withTopMargin;
    return withTopMargin && "margin-top: " + getPx(value) + ";";
  }, function (_ref3) {
    var withSpacing = _ref3.withSpacing,
        withBottomMargin = _ref3.withBottomMargin;
    return (withSpacing || withBottomMargin) && "margin-bottom: " + getPx(value) + ";";
  }, function (_ref4) {
    var withBottomPadding = _ref4.withBottomPadding;
    return withBottomPadding && "padding-bottom: " + getPx(value) + ";";
  });
});
export var fontSpacingKeys = ['withSpacing', 'withTopPadding', 'withTopMargin', 'withBottomMargin', 'withBottomPadding'];

/*
 * Wrapper that adds support for fixed height of typography elements
 */
export var fixedHeightMixin = function fixedHeightMixin(lineHeight) {
  return css(_templateObject2(), function (_ref5) {
    var fixedHeight = _ref5.fixedHeight,
        lines = _ref5.lines;
    return isDefined(lines) ? styleArrayForBreakpoints([lineHeight, lines, fixedHeight], function (_ref6) {
      var lineHeight = _ref6[0],
          lines = _ref6[1],
          fixedHeight = _ref6[2];
      return fixedHeight && lines > 0 ? "\n                display: -webkit-box;\n                position: relative;\n                overflow: hidden;\n                height: calc(" + getPx(lineHeight) + " * " + lines + ");\n                -webkit-line-clamp: " + lines + ";\n                -webkit-box-orient: vertical; \n              " : !fixedHeight && lines > 0 ? "\n                display: -webkit-box;\n                position: relative;\n                overflow: hidden;\n                max-height: calc(" + getPx(lineHeight) + " * " + lines + ");\n                -webkit-line-clamp: " + lines + ";\n                -webkit-box-orient: vertical;\n              " : "";
    }) : '';
  });
};
export var fixedHeightKeys = ['fixedHeight', 'lines'];